import React from 'react';
import types from 'prop-types';

// Styles

import './styles.scss';

// ----------------

// Type of props

MainContentStruct.propTypes = {
  className: types.string,
  children: types.node,
  style: types.object
};

// Default value for props

MainContentStruct.defaultProps = {
  className: ''
};

// ----------------

export default function MainContentStruct(props) {
  const { className, style, children } = props;

  return (
    <div className={`main-content-structure  ${className}`} style={style}>
      {children}
    </div>
  );
}
